export default function DividerLine({ classes }) {
	return <div className={`tw-border-slate-400 tw-border-b-[1px] tw-mb-4 ${classes}`}></div>;
}
